import app from '@/main';

export default {
    setSideNav: ({ commit }) => new Promise((resolve) =>{
        app.$http({
            url: `/static/side-nav.json`,
            method:'get',
        }).then(({ data }) => {
            resolve(data.sideNavInfo);
        });
    }),
    getCity: ({ commit }) => new Promise((resolve) =>{
        app.$http({
            url: `/static/city.json`,
            method:'get',
        }).then(({ data }) => {
            resolve(data);
        });
    }),
}